import { createSlice } from '@reduxjs/toolkit';

import { getPrevNextIds } from '../../helpers/common';

import { createTag, deleteTags, fetchAllTags, fetchTag, fetchTags, searchTags } from '../../redux/actions/tag';

const tagSlice = createSlice({
  name: 'tag',
  initialState: {
    error: null,
    loading: false,
    tags: [],
    tag: {},
    sortedData: []
  },
  reducers: {
    setSortedData: (state, action) => {
      state.sortedData = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      // Fetch All Tags
      .addCase(fetchAllTags.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllTags.fulfilled, (state, action) => {
        state.loading = false;
        state.tags = action.payload;
      })
      .addCase(fetchAllTags.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Tags
      .addCase(fetchTags.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTags.fulfilled, (state, action) => {
        state.tags = action.payload;
        state.loading = false;
      })
      .addCase(fetchTags.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Search Tags
      .addCase(searchTags.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchTags.fulfilled, (state, action) => {
        state.loading = false;
        state.tags = action.payload;
      })
      .addCase(searchTags.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Tag
      .addCase(fetchTag.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTag.fulfilled, (state, action) => {
        const { prev_id, next_id } = state.sortedData?.length
          ? getPrevNextIds(state.sortedData, action.payload?.id)
          : { prev_id: action.payload.prev_id, next_id: action.payload.next_id };
        state.tag = { ...action.payload, prev_id, next_id };
        state.loading = false;
      })
      .addCase(fetchTag.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Create Tag
      .addCase(createTag.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createTag.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createTag.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete Tags
      .addCase(deleteTags.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteTags.fulfilled, (state, action) => {
        state.loading = false;
        state.tags = state.tags.filter(record => !action.payload?.includes(record.id));
      })
      .addCase(deleteTags.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { setSortedData } = tagSlice.actions;
export default tagSlice.reducer;
